const NUMBER_OF_CONDENSED_COUNTRIES = 18;

export default NUMBER_OF_CONDENSED_COUNTRIES;
